import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	notifications: [],
};

const notificationSettingsSlice = createSlice({
	name: 'notificationSettings',
	initialState: initialState,
	reducers: {
		setNotificationSettings: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setNotificationSettings, reset } = notificationSettingsSlice.actions;

export default notificationSettingsSlice.reducer;